module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-20.8ffa8674.png";